// 商品管理路由
export default {
    path: 'goodsManage',
    component: () => import('@/components/RouterView'),
    redirect: '/goodsManage/goods/list',
    meta: {title: '商品管理'},
    children: [
        // 物流规则
        {
            path: 'logistics',
            component: () => import('@/components/RouterView'),
            redirect: '/goodsManage/logistics/list',
            meta: { title: '物流规则'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/goodsManage/logistics/list.vue'),
                    meta: {title: '物流规则列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/goodsManage/logistics/edit.vue'),
                    name: 'editLogistics',
                    meta: {title: '编辑物流规则'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/goodsManage/logistics/edit.vue'),
                    name: 'addLogistics',
                    meta: {title: '新建物流规则'},
                    props: true
                }
				
            ]
        },
		// 主题管理
		{
            path: 'theme',
            component: () => import('@/components/RouterView'),
            redirect: '/goodsManage/theme/list',
            meta: { title: '主题管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/goodsManage/theme/list.vue'),
                    meta: {title: '主题管理列表'}
                },
				{
				    path: 'edit/:id',
				    component: () => import('@/views/goodsManage/theme/edit'),
				    meta: {title: '主题编辑'},
				    props: true
				},
				{
				    path: 'add',
				    component: () => import('@/views/goodsManage/theme/edit'),
				    meta: {title: '新增主题'},
				},
            ]
		},
        // 商品列表
        {
            path:'goods',
            component: () => import('@/components/RouterView'),
            redirect: '/goodsManage/goods/list',
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/goodsManage/goods/list/index.vue'),
                    meta: {title: '商品列表'}
                },
				{
				    path: 'list2',
				    component: () => import('@/views/goodsManage/goods/list/index2.vue'),
				    meta: {title: '推荐商品列表'}
				},
				{
				    path: 'list',
				    component: () => import('@/views/goodsManage/goods/list'),
				    meta: {title: '商品列表'}
				},
                {
                    path: 'edit/:id',
                    component: () => import('@/views/goodsManage/goods/edit'),
                    meta: {title: '编辑商品'},
                    props: true
                },	
                {
                    path: 'add',
                    component: () => import('@/views/goodsManage/goods/edit'),
                    meta: {title: '新增商品'},
                },
				{
				    path: 'whitelist/:id',
				    component: () => import('@/views/goodsManage/goods/whitelist'),
				    meta: {title: '白名单列表'},
					props: true
				}
            ]
        },
        //订单管理
        {
            path: 'order',
            component: () => import('@/components/RouterView'),
            redirect: '/goodsManage/order/list',
            meta: {title: '订单管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/goodsManage/order/list'),
                    meta: {title: '订单列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/goodsManage/order/edit'),
                    meta: {title: '订单详情'},
                    props: true
                },
            ]
        },
		//售后管理
		{
		    path: 'aftersales',
		    component: () => import('@/components/RouterView'),
		    redirect: '/goodsManage/aftersales/list',
		    meta: {title: '售后管理'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/goodsManage/aftersales/list'),
		            meta: {title: '售后管理列表'}
		        },
		        {
		            path: 'edit/:id',
		            component: () => import('@/views/goodsManage/aftersales/edit'),
		            meta: {title: '售后处理'},
		            props: true
		        },
				{
				    path: 'set',
				    component: () => import('@/views/goodsManage/aftersales/set'),
				    meta: {title: '配置售后原因'},
				    props: true
				},
				
		    ]
		},
		//运费管理
		{
		    path: 'freight',
		    component: () => import('@/components/RouterView'),
		    redirect: '/goodsManage/freight/list',
		    meta: {title: '运费管理'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/goodsManage/freight/list'),
		            meta: {title: '运费管理列表'}
		        },
		        {
		            path: 'edit/:id',
		            component: () => import('@/views/goodsManage/freight/edit'),
		            meta: {title: '运费管理处理'},
		            props: true
		        }
				
		    ]
		},
        //退款日志
        {
            path: 'goodsRefund',
            component: () => import('@/components/RouterView'),
            redirect: '/goodsManage/goodsRefund/list',
            meta: {title: '退款日志'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/goodsManage/goodsRefund/list'),
                    meta: {title: '退款日志列表'}
                },
            ]
        },
    ]
}